import { Node } from "@/services/api";

export const removeNode = function (tree: Node, uid: string): Node {
	tree.children =  tree.children.filter((node) => node.uid !== uid);
	tree.children =  tree.children.map((node) => removeNode(node, uid));
	return tree;
};

